
import { defineComponent } from 'vue';
import CovidGalleryHeader from '../components/covid-gallery-header.vue';
import CovidGalleryContent from '../components/covid-gallery-content.vue';
import CovidGalleryFooter from '../components/covid-gallery-footer.vue';

export default defineComponent({
	components: {
		CovidGalleryHeader,
		CovidGalleryContent,
		CovidGalleryFooter,
	}
})
